<template>
  <section>
    <div class="popups">
      <b-sidebar
        v-model="showFilters"
        right
        shadow
        backdrop
        bg-variant="white"
        no-header
      >
        <template #default="{ hide }">
          <div class="container sidebar-header">
            <b-row>
              <div class="col">
                <b-button
                  variant="primary"
                  @click="
                    applyFilters();
                    loadItems();
                    showFilters = false;
                  "
                  >Apply</b-button
                >
              </div>
              <div class="col-auto text-right">
                <b-button variant="link" class="ml-3 px-0" @click="hide">
                  <i class="fa fa-times"></i>
                </b-button>
              </div>
            </b-row>
          </div>

          <div class="px-3 py-2">
            <b-form-group label="Search:">
              <b-form-input v-model="formFilters.search" />
            </b-form-group>
          </div>
        </template>
      </b-sidebar>
    </div>

    <div class="header">
      <div class="header-body">
        <div class="row align-items-end">
          <div class="col">
            <h1 class="header-title">
              API Access
            </h1>
          </div>
          <div class="col-auto">
            <router-link
              :to="{ name: 'Integrations.ApiAccess.Create' }"
              class="btn btn-success"
            >
              <i class="mr-2 fa fa-plus" />
              Add New
            </router-link>

            <!-- <b-button
              variant="primary"
              class="ml-2"
              @click="showFilters = !showFilters"
            >
              <i class="fa fa-filter mr-2"></i>
              Filters
            </b-button> -->
          </div>
        </div>
      </div>
    </div>

    <TableListing
      class="mb-0"
      :loading-page="loadingItems"
      :failed-loading="failedLoadItems"
      head-variant="dark"
      :items.sync="items"
      :fields.sync="fields"
      :pagination.sync="pagination"
      :options.sync="tableOptions"
      v-on:pagination-changed="loadItems"
    >
      <template v-slot:cell(id)="data">
        <div class="d-flex">
          <b-button variant="primary" class="mr-1" :to="{
              name: 'Integrations.ApiAccess.Edit',
              params: { id: data.item.id }
            }">
            Edit
          </b-button>
        </div>
      </template>
      <template v-slot:cell(apiKey)="data">
        <div class="d-flex align-items-center">
          <span class="mr-2">
            {{ revealedKeys[data.item.id] ? data.item.apiKey : '••••••••••••••••' }}
          </span>
          <b-button
            variant="link"
            size="sm"
            class="p-0 mr-2"
            @click="toggleReveal(data.item.id, 'key')"
            v-b-tooltip.hover
            :title="revealedKeys[data.item.id] ? 'Hide' : 'Show'"
          >
            <i :class="revealedKeys[data.item.id] ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
          </b-button>
          <b-button
            v-if="revealedKeys[data.item.id]"
            variant="link"
            size="sm"
            class="p-0"
            @click="copyToClipboard(data.item.apiKey, 'API Key')"
            v-b-tooltip.hover
            title="Copy"
          >
            <i class="fa fa-copy"></i>
          </b-button>
        </div>
      </template>
      <template v-slot:cell(apiSecret)="data">
        <div class="d-flex align-items-center">
          <span class="mr-2">
            {{ revealedSecrets[data.item.id] ? data.item.apiSecret : '••••••••••••••••' }}
          </span>
          <b-button
            variant="link"
            size="sm"
            class="p-0 mr-2"
            @click="toggleReveal(data.item.id, 'secret')"
            v-b-tooltip.hover
            :title="revealedSecrets[data.item.id] ? 'Hide' : 'Show'"
          >
            <i :class="revealedSecrets[data.item.id] ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
          </b-button>
          <b-button
            v-if="revealedSecrets[data.item.id]"
            variant="link"
            size="sm"
            class="p-0"
            @click="copyToClipboard(data.item.apiSecret, 'API Secret')"
            v-b-tooltip.hover
            title="Copy"
          >
            <i class="fa fa-copy"></i>
          </b-button>
        </div>
      </template>
      <template v-slot:cell(createDateTimeUtc)="data">
        <span
          v-if="
            data.item.createDateTimeUtc &&
              !data.item.createDateTimeUtc.endsWith('Z')
          "
          >{{
            (data.item.createDateTimeUtc + 'Z') | moment('MMM Do YY, h:mm a')
          }}</span
        >
        <span v-else-if="data.item.createDateTimeUtc">{{
          data.item.createDateTimeUtc | moment('MMM Do YY, h:mm a')
        }}</span>
      </template>
      <template v-slot:cell(name)="data">
        <span>{{ data.item.name }}</span>
      </template>
    </TableListing>
  </section>
</template>

<script>
import TableListing from '@/views/components/TableListing.vue';
import { crudMixinGen, myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
export default {
  name: 'APIAccess.Index',
  mixins: [crudMixinGen('apiAccess'), myCommonDataMixin],
  components: {
    TableListing
  },

  data: () => ({
    fields: [
      { key: 'name', label: 'Name', sortable: false },
      { key: 'apiKey', label: 'API Key', sortable: false },
      { key: 'apiSecret', label: 'API Secret', sortable: false },
      { key: 'createDateTimeUtc', label: 'Created At', sortable: true },
      { key: 'id', label: 'Actions', sortable: false }
    ],
    revealedKeys: {},
    revealedSecrets: {}
  }),
  computed: {
  },

  mounted() {
    this.loadItems();
  },

  methods: {
    toggleReveal(itemId, type) {
      if (type === 'key') {
        this.$set(this.revealedKeys, itemId, !this.revealedKeys[itemId]);
      } else if (type === 'secret') {
        this.$set(this.revealedSecrets, itemId, !this.revealedSecrets[itemId]);
      }
    },
    copyToClipboard(text, label) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text)
          .then(() => {
            this.$bvToast.toast(label + ' copied to clipboard', {
              title: 'Success',
              variant: 'success',
              solid: true,
              autoHideDelay: 2000
            });
          })
          .catch(err => {
            console.error('Failed to copy:', err);
          });
      } else {
        this.$swal('Your browser does not support this action!');
      }
    }
  }
};
</script>
